import * as React from 'react';
import { useDispatch } from 'react-redux';

import { FilterTextInput, IFilterTextInputProps } from '../../../../components/FilterTextInput';
import { setSearchText } from '../../../../actions/searchRealtors';
import { useSearchText } from '../../../../hooks/selectors/searchRealtors';

export const SearchTextContainer: React.FC = () => {
  const dispatch = useDispatch();
  const searchText = useSearchText('');

  const handleSetSearchText = React.useCallback<NonNullable<IFilterTextInputProps['onChange']>>(
    event => {
      dispatch(setSearchText(event.target.value));
    },
    [dispatch],
  );

  return (
    <FilterTextInput
      placeholder="Имя, номер ID или телефон риелтора"
      onChange={handleSetSearchText}
      value={searchText}
      grow={1}
    />
  );
};

SearchTextContainer.displayName = 'SearchTextContainer';
